// extracted by mini-css-extract-plugin
export default {"wrap":"HealthIndicator_wrap__SruNT","value":"HealthIndicator_value__94HOJ"};